import { useQuery } from "@tanstack/react-query";
import { getWebsiteSettings } from "../api/apiWebsiteSettings";
import i18next from "i18next";

export function useWebsiteSettings() {
    const { isLoading, data, error } = useQuery({
        queryKey: ["website-settings", i18next.language],
        queryFn: () => getWebsiteSettings(),
        retry: false,
    });

    return { isLoading, error, settings: data?.data?.settings || {} };
}
